import React from 'react'
import { Link } from "react-router-dom"
import khub from '../database/khub.json'
import LazyLoad from 'react-lazyload';
import { useInternationalization } from '../features/i18n';

const Footer = ({customPadding}) => {
  const { translate } = useInternationalization()

  return (
    <footer style={{background: '#111', color: '#aaa'}}>
      <div className={`container mx-auto font-accent ${customPadding ? customPadding : 'pt-16 pb-6 lg:pb-24 lg:pt-24'}`}>
        <div className="flex flex-wrap -mx-2 lg:-mx-4 uppercase text-xs lg:text-sm leading-7">
          <div className="w-full lg:w-4/12 px-2 lg:px-4 mb-10 lg:mb-0">
            <Link to="/">
              <LazyLoad height={200} once>
                <img className="footer__logo" src="/images/khub_logo_white.png" alt="KHUB" style={{maxHeight: '60px'}}/>
              </LazyLoad>
            </Link>
          </div>
          <div className="w-1/2 lg:w-2/12 px-2 lg:px-4 mb-4 lg:mb-0">
            <ul>
              <li>
                <Link to="/about">
                  {translate('FOOTER', 'footer_about')}
                </Link>
              </li>
              <li>
                <Link to="/career">
                  {translate('FOOTER', 'footer_career')}
                </Link>
              </li>
            </ul>
          </div>
          <div className="w-1/2 lg:w-2/12 px-2 lg:px-4 mb-4 lg:mb-0 order-4 lg:order-3">
            <ul>
              <li>
                <Link to="/organization">
                  {translate('ORGANIZATION', 'plural')}
                </Link>
              </li>
              <li>
                <Link to="/program">
                  {translate('PROGRAM', 'plural')}
                </Link>
              </li>
              <li>
                <Link to="/event">
                  {translate('EVENT', 'plural')}
                </Link>
              </li>
              <li>
                <Link to="/resource">
                  {translate('RESOURCE', 'plural')}
                </Link>
              </li>
              <li>
                <Link to="/blog">
                  {translate('BLOG', 'singular')}
                </Link>
              </li>
            </ul>
          </div>
          <div className="w-1/2 lg:w-2/12 px-2 lg:px-4 mb-4 lg:mb-0 lg:order-4">
            <ul>
              {/* <li>API</li> */}
              <li>
                <Link to="/terms-conditions">
                  {translate('FOOTER', 'footer_pnt')}
                </Link>
              </li>
              <li>
                <Link to="/faq">
                  {translate('FOOTER', 'footer_faq')}
                </Link>
              </li>
              <li>
                <Link to="/contact">
                  {translate('FOOTER', 'footer_contact')}
                </Link>
              </li>
            </ul>
          </div>
          <div className="w-1/2 lg:w-2/12 px-2 lg:px-4 mb-4 lg:mb-0 order-5">
            <LazyLoad height={100} once>
              <ul className="flex items-center lg:justify-end">
                <li className="pr-3 lg:pr-0 lg:pl-3">
                  <a
                    href={khub.social_media_links.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/icons/khub_ig.jpg" alt="Instagram" width="30" height="30"/>
                  </a>
                </li>
                <li className="pr-3 lg:pr-0 lg:pl-3">
                  <a
                    href={khub.social_media_links.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/icons/khub_fb.jpg" alt="Facebook" width="30" height="30"/>
                  </a>
                </li>
                <li className="pr-3 lg:pr-0 lg:pl-3">
                  <a
                    href={khub.social_media_links.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/images/icons/khub_yt.jpg" alt="YouTube" width="30" height="30"/>
                  </a>
                </li>
              </ul>
            </LazyLoad>
          </div>
        </div>
      </div>
      <div className="container mx-auto">
        <div className="pb-10 lg:pb-5 py-5 border-gray-800 border-t">
          <p className="text-xs" style={{color: '#666'}}>
            {khub.copyright}
          </p>
        </div>
      </div>
    </footer>
  )
}

export { Footer }
